var EvaluationService = require('services/evaluation-service');
var AssessmentViewService = require('services/assessment-service');
var utils = require('lib/utils');

var AssessmentService = function() {
  this.getRedirectUrlForCurrentPage = function(){
    var currentPage = EF.module.currentActivity.currentPage;
    var redirectUrl = "#" + currentPage.path();
    return redirectUrl;
  };

  this.triggerAssessment = function(blockView){
    var redirectUrl = this.getRedirectUrlForCurrentPage();
    var data = {
      event_type: 'assessment-initialized',
      redirectUrl: redirectUrl,
      slug: blockView.model.get('assessment_slug')
    };
    window.parent.postMessage(data, '*');
  };

  this.userHasCompletedAssessment = function(courseSlug){
    return EvaluationService.userHasCompletedEvaluation(courseSlug);
  };

  this.getBestScore = function(courseSlug){
    return EvaluationService.bestScore(courseSlug);
  };

  this.loadCourseAssessment = function(view) {
    return new Promise((resolve, reject) => {
      const evaluation = EvaluationService.findEvaluationBySlug(view.model.get('assessment_slug'));
      const responseSet = EvaluationService.getResponseSetFromModel(view.model.get('assessment_slug'));

      const sections = evaluation.get('sections');
      const questions = new EF.Collections.Assessments.QuestionsCollection(sections.reduce((result, section) => {
        return result.concat(section.questions);
      }, []));

      view.assessment.set('questions', questions);
      view.assessment.set('original_questions', questions);
      view.assessment.set('response_set', responseSet);

      const attempt = new EF.Models.Assessments.Attempt(1, { assessment: view.assessment });

      attempt.set({
        id: responseSet.id,
        token: EvaluationService.findEvaluationTokenBySlug(view.model.get('assessment_slug'))
      });
      view.assessment.set('attempt', attempt);
      resolve(view);
    });
  };

  this.getUrl = function(assessment) {
    return `${assessment.get('response_set').endpoint}/response_sets/${assessment.get('response_set').id}.json?include=evaluation,sections.questions.answers`;
  };

  this.isAttemptCorrect = function(results, questionId) {
    if(Array.isArray(results.incorrect_answers)) {
      return !results.incorrect_answers.some(ia => ia.question_id === questionId);
    }
  };

  this.isAttemptComplete = function (attempt) {
    var answers = $.map(attempt.get('answers'), function (answer) {
      return answer.question_id;
    });
    var questions = attempt.assessment.get('original_questions') || this.assessment.get('questions');
    return questions.every(function (q) {
      return $.inArray(q.get('id'), answers);
    });
  };
  this.isAttemptFinished = function (attempt) {
    return attempt.get('status') == 'completed';
  };
  this.parseAttempt = function(data){
    return utils.sanifyJsonApiObject(data.data, data.included);
  }
  this.refreshActivityProgress = function () { };
};

module.exports = new AssessmentService();
